module.exports = __webpack_public_path__ + "static/incidences-11d9726d32cea2bfec9bd0e8e18a950e.png";